import { Component, OnInit } from '@angular/core';
import { ConfirmEventType, ConfirmationService } from 'primeng/api';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-authentication-invalid-dialog',
  templateUrl: './authentication-invalid-dialog.component.html',
  styleUrls: ['./authentication-invalid-dialog.component.scss']
})
export class AuthenticationInvalidDialogComponent implements OnInit {
  showModal: boolean = false;

  constructor(private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.authenticationService.obterTokenExpirado().subscribe((resp: boolean) => {
      if (resp === true) {
        this.showModal = true;
        this.openModal();
      }
    })
  }

  openModal() {
    this.confirmationService.confirm({
      header: 'Sua sessão expirou',
      message: 'Sua sessão expirou, você será redirecionado para o login.',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.showModal = false;
        this.authenticationService.logout();
      },
      reject: () => {
        this.showModal = false;
      }
    });
  }
}
